<template lang="pug">
.order-detail
  modal(
    name='product-chooser'
    width='90%' height='95%'
    transition='modal-transition'
  )
    ProductChooser(
      :customer="customer"
      @close="$modal.hide('product-chooser')"
      @selected="addProduct($event)"
      :preSelectedProductsId='selectedProductsId'
    )
  GenericCard.productList(size='80' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .container
        .row
          .col
            .pt-4.pb-2.px-2
              .card-title
                template(v-if='isQuotation')
                  | ใบเสนอราคาหมายเลข \#{{orderId}}
                template(v-else)
                  | รายงานการขายเลขที่ \#{{orderId}}
                InfoTooltip(
                  info="เลขที่มีสัญลักษณ์ # และเป็นตัวเอียงคือเลขที่รายการขั่วคราวก่อนเปิดบิลจริง")
                span.ml-4 {{ formattedDate }}
              CustomerDetailHeader.mt-4(:isCompact="true" :data='customer', :showUnpaid='false')
          .col-4
            .pt-4.text-right
              button.btn.btn-upa-secondary(
                @click="$modal.show('product-chooser')") เพิ่มสินค้า
              InputWithIconSlot.mt-2(
                v-model="orderInfo.po" placeholder="เลขที่ใบสั่งซื้อ" width="100%")
                i.fa.fa-pen
              p.mt-2.text-secondary
                template(v-if="warehouse !== null")
                  span.text-danger เปลี่ยนคลังเป็น {{warehouseName}}
                  br
                | {{(isVat)? $dictionary.receiptType[0]: $dictionary.receiptType[1] }}
                br
                | {{$dictionary.deliveryType[deliveryType]}}
                //- br
                //- | {{ deliveryCarrier }}
      //- hr.m-0
      .d-flex.flex-column.px-4.py-3
        .card-section-title รายการสินค้า
      hr.m-0

    CustomTable.px-3(
      :columns="$tableColumns.saleProducts"
      :data="selectedProducts"
      :showEmptyStateMessage='false'
    )
      //- :data="processedSelectedProductsForTable"
      template(v-slot:endTableSlot="rowData")
        button.delete-button(@click="removeProductIndex(rowData.index)")
          img.img-24(src="@/assets/icons/delete.png")
    .mt-0.border-secondary.rounded.text-center.mx-4.my-2.py-4.px-5(
      v-if="selectedProducts.length === 0"
      style="border-style: dashed; border-width: 1px; opacity: 0.4"
    ) เริ่มเพิ่มสินค้าที่ปุ่มด้านขวาบน ↗


    .bg-white
      hr.mb-0
      .d-flex.flex-column.px-4.pb-4
        .d-flex
          .additional-options.flex-fill.pr-3
            InputWithIconSlot.mt-3.w-100(
              width="100%"
              type="textarea" v-model="orderInfo.remark" placeholder="หมายเหตุระบุในบิล")
              i.fa.fa-pen
            template(v-if="orderInfo.remark !== ''")
              .mt-1.pl-2.text-danger: small
                | ▲ ข้อความในช่องนี้ยกเว้นข้อความที่ส่งคลังจะถูกระบุใน
                u บิลลูกค้า
            .mt-1.text-secondary
              small(v-if="warehouseMsg && warehouseMsg !== ''")
                | ข้อความส่งคลัง: {{warehouseMsg[1]}}
              small(v-else)
                | ครอบข้อความส่งคลังด้วยเครื่องหมาย ##
                InfoTooltip(
                  info="เช่น ##คัดสินค้าดีๆ##")
            InputWithIconSlot.mt-3.w-100(
              width="100%"
              rows="2"
              type="textarea" v-model="orderInfo.conversation" placeholder="ข้อความภายใน")
              i.fa.fa-comments
          .align-self-end.mt-2.py-2
            .d-flex.justify-content-between
              .total-price.text-right.flex-fill: small น้ำหนักรวมทั้งหมด
              .total-price.ml-4: small {{totalWeight | currency}}
            .d-flex.justify-content-between
              .total-price.text-right.flex-fill: small รวมค่าสินค้าทั้งสิ้น
              .total-price.ml-4: small {{totalSellPrice | currency}}
            .d-flex.justify-content-between.mt-2
              .total-price.text-right.flex-fill รวมค่าคอมมิชชั่นที่ได้รับ
              .total-price.ml-4 {{totalCommission | currency}}
        button.btn.btn-primary.align-self-center.mt-3(
          @click="submitOrder"
          :disabled='!isNewOrderDetailComplete'
        )
          template(v-if='editingOrderId')
            | บันทึกการแก้ไข
          template(v-else)
            | ดำเนินการ
          //- .text-large {{ isNewOrderDetailComplete }}

</template>

<script>
import CustomerDetailHeader from '@/components/customers/CustomerDetailHeader.vue';
import ProductChooser from '@/components/new-order/product-chooser/ProductChooser.vue';

import calculator from '@/calculator';

export default {
  props: {
    customer: {},
    isVat: {},
    isQuotation: {},
    deliveryType: {},
    deliveryTypeExtra: {},
    deliveryCarrier: {},

    preSelectedProducts: {},
    extraRemarks: {},
    editingOrderId: {},

    customerNameIndex: {},
    useSpecialName: {},

    warehouse: {},
  },
  watch: {
    preSelectedProducts() {
      if (this.preSelectedProducts) {
        this.selectedProducts = this.preSelectedProducts;
        // just pass from props -> data
      }
    },
    extraRemarks() {
      if (this.extraRemarks) {
        this.orderInfo.remark = this.extraRemarks;
        // just pass from props -> data
      }
    },
  },
  async mounted() {
    const wareHouseRes = await this.$api.order.availableWarehouse();
    if (wareHouseRes.status === 200) {
      this.availableWarehouse = wareHouseRes.data;
    }
    if (this.preSelectedProducts) {
      this.selectedProducts = this.preSelectedProducts;
    }
    if (this.extraRemarks) {
      this.orderInfo.remark = this.extraRemarks;
    }
    if (!this.editingOrderId) {
      const res = await this.$api.order.getNextId((this.isQuotation) ? 'quote' : 'order');
      if (res.status === 200) {
        this.nextId = res.data;
      }
    }
  },
  data: () => ({
    nextId: '...',
    selectedProducts: [],
    selectedProductsId: [],
    availableWarehouse: [],
    orderInfo: {
      po: '',
      remark: '',
      conversation: '',
    },
  }),
  computed: {
    warehouseMsg() {
      if (this.orderInfo && this.orderInfo.remark) {
        return this.orderInfo.remark.match(/##([^)]+)##/);
      }
      return '';
    },
    warehouseName() {
      if (this.availableWarehouse) {
        const list = this.availableWarehouse.filter((elm) => {
          if (elm.value && this.warehouse.toString() === elm.value.toString()) return true;
          return false;
        });
        if (list.length > 0) return list[0].text;
      }
      return '';
    },
    formattedDate() {
      // return new Date();
      return this.$moment().format('Do MMMM YYYY');
    },
    // processedSelectedProductsForTable() {
    //   const res = this.selectedProducts.map(elm => ({
    //     ...elm.product,
    //     amount: elm.amount,
    //     sellPrice: elm.sellPrice,
    //     total: elm.amount * elm.sellPrice,
    //   }));
    //   // console.log(res);
    //   return res;
    // },
    orderId() {
      if (this.editingOrderId) {
        return this.editingOrderId;
      }
      return this.nextId;
    },
    totalWeight() {
      let res = 0;
      this.selectedProducts.forEach((elm) => {
        res += elm.amount * (elm.product ? elm.product.weight : 0);
      });
      return res;
    },
    totalSellPrice() {
      let res = 0;
      this.selectedProducts.forEach((elm) => {
        res += elm.amount * elm.sellPrice;
      });
      return res;
    },
    totalCommission() {
      let res = 0;
      this.selectedProducts.forEach((elm) => {
        res += calculator.productCommission(
          elm.product.levels,
          elm.sellPrice,
          elm.amount,
        );
      });
      return res;
    },
    isNewOrderDetailComplete() {
      return this.deliveryType
        && (this.deliveryTypeExtra || this.deliveryType === 'store' || this.deliveryType === 'pickup')
        && this.deliveryCarrier !== undefined
        && this.customerNameIndex
        && this.useSpecialName !== undefined
        && this.selectedProducts && this.selectedProducts.length > 0;
    },
  },
  methods: {
    addProduct(product) {
      // console.log(product);
      if (product.product) {
        this.selectedProducts.push(product);
        this.selectedProductsId.push(product.product.productCode);
      } else {
        alert('ไม่สามารถเพิ่มสินค้าได้');
      }
      this.$modal.hide('product-chooser');
    },
    removeProductIndex(productIndex) {
      // console.log(productIndex);
      this.selectedProducts.splice(productIndex, 1);
      this.selectedProductsId.splice(productIndex, 1);
      // console.log(this.selectedProducts);
    },

    async submitOrder() {
      // prepare Order items
      const { selectedProducts } = this;
      const orderItems = [];
      for (let i = 0; i < selectedProducts.length; i += 1) {
        const item = selectedProducts[i];
        orderItems.push({
          product_id: item.product.productCode,
          amount: item.amount,
          price: item.sellPrice,
        });
      }

      // data object to be POSTed
      let SHIP_TO = '';
      if (this.deliveryType === 'branch_and_site' || this.deliveryType === 'forward') {
        SHIP_TO = this.deliveryTypeExtra;
      }
      const { orderInfo } = this;
      // when an empty string is submitted, laravel will throw error
      // fix: change to undefined -> so they won't even be submitted in the first place
      if (!orderInfo.po) {
        orderInfo.po = undefined;
      }
      if (!orderInfo.conversation) {
        orderInfo.conversation = undefined;
      }
      if (!orderInfo.remark) {
        orderInfo.remark = undefined;
      }

      const sendToChat = orderInfo.conversation;

      const newOrderData = {
        is_quotation: this.isQuotation,

        customer_id: this.customer.id,
        has_vat: this.isVat,
        ship_type: this.deliveryType,
        ship_to: SHIP_TO,
        carrier: this.deliveryCarrier,
        customer_po_no: orderInfo.po,
        // internal_message: orderInfo.conversation,
        remarks: orderInfo.remark,
        items: orderItems,
        warehouse: this.warehouse,

        customer_name_index: this.customerNameIndex, // TODO: change param name
        use_special_name: this.useSpecialName, // TODO: change param name
      };

      // console.log(JSON.stringify(newOrderData));
      // console.log(newOrderData);
      try {
        let res = {};

        // submit order
        if (this.editingOrderId) {
          res = await this.$api.order.update(newOrderData, this.editingOrderId);
        } else {
          res = await this.$api.order.submit(newOrderData);
        }

        if (res.status === 201) {
          let orderId;
          if (this.editingOrderId) { // existing
            orderId = this.editingOrderId;
          } else { // new order
            orderId = res.data.order_id;
          }
          // console.log(res);
          if (sendToChat) {
            await this.$api.history.submitChatMessages(orderId, sendToChat);
          }
          this.$emit('done', orderId);
        }
      } catch (e) {
        alert(e.message);
      }
    },
  },
  components: {
    CustomerDetailHeader,
    ProductChooser,
  },
};
</script>

<style lang="scss">
.order-detail {
  .delete-button {
    background: none;
    border: none;
  }
}
.total-price {
  font-size: 22px;
}
</style>
